<template>
    <div class="my-transfer">
        <mt-header fixed title="老人转入">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="my-content">
            <mt-navbar v-model="selected">
                <mt-tab-item id="0">待审核</mt-tab-item>
                <mt-tab-item id="1">已接收</mt-tab-item>
                <mt-tab-item id="-1">已拒绝</mt-tab-item>
            </mt-navbar>
            <div class="content-body">
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item id="0" v-if="selected==='0'">


                        <ul class="mui-table-view transfer-elder-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell transfer-block" v-for="item in list">
                                <div class="transfer-block-body">
                                    <div class="transfer-elder">{{ item.name }} <span>待审核</span> <span class="action-time">{{ item.created_at }}</span></div>
                                    <div class="transfer-info">
                                        <div class="transfer-from">{{ item.from_station }}</div>
                                        <div class="transfer-line">--></div>
                                        <div class="transfer-to">{{ item.to_station }}</div>
                                    </div>
                                </div>
                                <div class="receive-action">
                                    <div class="receive-action-button accept-button" @click="acceptTransfer(item.id)">
                                        通过申请
                                    </div>
                                    <div class="receive-action-button refuse-button" @click="refuseTransfer(item.id)">
                                        拒绝申请
                                    </div>
                                </div>
                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>
                    <mt-tab-container-item id="1" v-if="selected==='1'">

                        <ul class="mui-table-view transfer-elder-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell transfer-block" v-for="item in list">
                                <div class="transfer-block-body">
                                    <div class="transfer-elder">{{ item.name }} <span class="accept">已接收</span><span class="action-time">{{ item.updated_at }}</span></div>
                                    <div class="transfer-info">
                                        <div class="transfer-from">{{ item.from_station }}</div>
                                        <div class="transfer-line">--></div>
                                        <div class="transfer-to">{{ item.to_station }}</div>
                                    </div>
                                </div>
                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>
                    <mt-tab-container-item id="-1" v-if="selected==='-1'">
                        <ul class="mui-table-view transfer-elder-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell transfer-block" v-for="item in list">
                                <div class="transfer-block-body">
                                    <div class="transfer-elder">{{ item.name }} <span class="refuse">已拒绝</span><span class="action-time">{{ item.updated_at }}</span></div>
                                    <div class="transfer-info">
                                        <div class="transfer-from">{{ item.from_station }}</div>
                                        <div class="transfer-line">--></div>
                                        <div class="transfer-to">{{ item.to_station }}</div>
                                    </div>
                                </div>
                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
</template>
<script>
    import { MessageBox } from 'mint-ui';

    export default{
        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                selected:"0",

                //初始化无限加载相关参数
                list:[],
                queryLoading: true,
                pageNum:1,
            }
        },

        created(){
           this.getTransfer(this.selected,this.pageNum);
        },

        watch:{
            selected:{
                handler(){
                    this.pageNum = 1;
                    this.list = [];
                    this.queryLoading = true;
                    this.getTransfer(this.selected,1,true);
                }
            }
        },

        methods:{
            getTransfer(status,page,changed = false){
                console.log(this.queryLoading);
                this.$axios.get('/my/receive?openid='+this.openid+'&status='+status+'&page='+page)
                    .then(data => {

                        if (data.data.code === 'OK') {

                            if(changed){
                                this.list = data.data.data;
                            }else{
                                this.list = this.list.concat(data.data.data);
                            }

                            if(data.data.data.length<10){
                                this.queryLoading = false;
                            }
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            acceptTransfer(id){
                MessageBox.confirm('确定执行此操作?').then(action => {
                    this.$axios.post('/my/acceptTransfer',{openid:this.openid,elderTransfer:id})
                        .then(data => {

                            if (data.data.code === 'OK') {
                               this.$toast('操作成功');
                               setTimeout(function(){
                                   location.reload();
                               },2000);
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                });
            },

            refuseTransfer(id){
                MessageBox.confirm('确定执行此操作?').then(action => {
                    this.$axios.post('/my/refuseTransfer',{openid:this.openid,elderTransfer:id})
                        .then(data => {

                            if (data.data.code === 'OK') {
                                this.$toast('操作成功');
                                setTimeout(function(){
                                    location.reload();
                                },2000);
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                });
            },

            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.getTransfer(this.selected,this.pageNum);

            },
        }
    }
</script>
<style>
    .content-body{
        padding:20px;
    }

    .transfer-elder{
        padding-bottom:20px;
        font-size:16px;
        font-weight: 800;
    }

    .transfer-elder span{
        font-size:12px;
        background:#ffcb01;
        color:#fff;
        padding:0 10px;
        margin-left:8px;
    }

    .transfer-elder span.action-time{
        background: none;
        color: #333;
        float: right;
        padding-top: 5px;
        padding-right: 0;
    }

    .transfer-elder span.accept{
        background:#00a65a;
    }

    .transfer-elder span.refuse{
        background:#b8bbbf;
    }

    .transfer-block{
        margin-bottom: 20px;
    }

    .transfer-block-body{
        background:#fff;
        padding:20px;
    }
    .transfer-info{
        display:flex;
        justify-content: space-between;
    }

    .receive-action{
        font-size:12px;
        text-align:center;
        color:#fff;
        display:flex;
    }

    .receive-action-button{
        flex:1;
        padding:10px 0;
    }

    .accept-button{
        background:#ffc107;
    }

    .refuse-button{
        background:#b8bbbf;
    }

    ul.transfer-elder-list{
        margin:0
    }

    .transfer-from,.transfer-to{
        font-size:14px;
        color:#5a5a5a;
    }

</style>


// WEBPACK FOOTER //
// src/pages/my/receive.vue